import ConfigManager from './ConfigManager';
export default ConfigManager;
export * from './configManager.reducer';
